import { graphql } from '@client/graphql/types';
import { useQuery } from '@apollo/client';

const QUERY = graphql(`
  query Invoice($invoiceID: ID!) {
    invoice(invoiceID: $invoiceID) {
      id
      total
      place
      shortID
      branchId
      createdAt
      invoiceLines {
        id
        title
        subtitle
        quantity
        price
        total
      } 
      invoiceSecondaryLines {
        id
        title
        price
        description
        invoiceCategory
      }
    }
  }
`);

export function useInvoiceManagement(invoiceID: string) {
  return useQuery(QUERY, {
    variables: {
      invoiceID: invoiceID,
    },
  });
}
